/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsServer = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var NotificationsServer = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        NotificationsService: function () {
            return function (headers) {
                var service = {
                    broadcastConferenceInfo: function (broadcastConferenceInfoRequest) {
                        return httpClient.invoke('POST', '/v1/notifications/broadcastConferenceInfo', broadcastConferenceInfoRequest, headers);
                    },
                };
                service.broadcastConferenceInfo.__http_method = 'POST';
                service.broadcastConferenceInfo.__http_url = '/v1/notifications/broadcastConferenceInfo';
                return service;
            };
        },
        NotificationsSettings: function () {
            return function (headers) {
                var service = {
                    get: function (getSetupRequest) { return httpClient.invoke('GET', '/v1/notifications', getSetupRequest, headers); },
                    getNotificationView: function (getNotificationViewRequest) {
                        return httpClient.invoke('GET', '/v1/notificationsView', getNotificationViewRequest, headers);
                    },
                    missedBooking: function (missedBookingRequest) {
                        return httpClient.invoke('POST', '/v1/notifications/missedBooking', missedBookingRequest, headers);
                    },
                    pricingPlanError: function (pricingPlanErrorRequest) {
                        return httpClient.invoke('POST', '/v1/notifications/invalidPricingPlanSetup', pricingPlanErrorRequest, headers);
                    },
                    setup: function (setupRequest) { return httpClient.invoke('PATCH', '/v1/notifications', setupRequest, headers); },
                    waitingListSlot: function (waitingListSlotRequest) {
                        return httpClient.invoke('POST', '/v1/notifications/waitinListSlot', waitingListSlotRequest, headers);
                    },
                };
                service.get.__http_method = 'GET';
                service.get.__http_url = '/v1/notifications';
                service.getNotificationView.__http_method = 'GET';
                service.getNotificationView.__http_url = '/v1/notificationsView';
                service.missedBooking.__http_method = 'POST';
                service.missedBooking.__http_url = '/v1/notifications/missedBooking';
                service.pricingPlanError.__http_method = 'POST';
                service.pricingPlanError.__http_url = '/v1/notifications/invalidPricingPlanSetup';
                service.setup.__http_method = 'PATCH';
                service.setup.__http_url = '/v1/notifications';
                service.waitingListSlot.__http_method = 'POST';
                service.waitingListSlot.__http_url = '/v1/notifications/waitinListSlot';
                return service;
            };
        },
    };
};
exports.NotificationsServer = NotificationsServer;
exports.NotificationsServer.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map